import axios from '../axios/interceptor';

export const fetchDashboard = async (businessId) => {
    const response = await axios.get(`business/${businessId}/dashboard`);
    return response.data; 
}